import { render, staticRenderFns } from "./dayTopic.vue?vue&type=template&id=5bc99623&"
import script from "./dayTopic.vue?vue&type=script&lang=js&"
export * from "./dayTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports